import styled, { css } from 'styled-components';
import Logo from './index';

export const LogoContainer = styled.div`
  display: inline-block;
  max-width: 100%;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'unset')};
  ${(props) => {
    switch (props.size) {
      case Logo.SIZE.SMALL:
        return css`
          height: auto;
          width: 135px;
          max-height: 30px;

          @media ${props.theme.device.tabletL} {
            max-height: 35px;
          }
        `;
      case Logo.SIZE.LARGE:
        return css`
          height: auto;
          width: 200px;
          max-height: 80px;
        `;
      case Logo.SIZE.XL:
        return css`
          height: auto;
          width: 340px;
        `;
      case Logo.SIZE.MEDIUM:
      default:
        return css`
          height: auto;
          width: 155px;
          max-height: 44px;
        `;
    }
  }};
`;

export const LogoImg = styled.img`
  max-width: 100%;
  max-height: inherit;
`;
